import axios from 'axios';
import {
  helperGetApiHeaders,
  helperGetApiSeriesUrlRoute,
  helperConvertApiRoute,
  apiErrorHandler,
} from 'helpers/ApiHelper';

export const FETCH_LATEST_EPISODE_SERIES = 'FETCH_LATEST_EPISODE_SERIES';
export const FETCH_LATEST_EPISODE_VIDEO = 'FETCH_LATEST_EPISODE_VIDEO';

export function fetchLatestEpisodeSeries(showId, accessToken, deviceId) {
  const pageType = 'showsQuery';
  const request = axios
    .get(
      helperGetApiSeriesUrlRoute({ showId }),
      helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
    )
    .catch(e => apiErrorHandler({ error: e }));
  return {
    type: FETCH_LATEST_EPISODE_SERIES,
    payload: request,
  };
}

export function fetchLatestEpisodeVideo(seriesScreenUrl, accessToken, deviceId) {
  const pageType = 'seriesDetail';
  const request = axios
    .get(
      helperConvertApiRoute(seriesScreenUrl),
      helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
    )
    .catch(e => apiErrorHandler({ error: e }));
  return {
    type: FETCH_LATEST_EPISODE_VIDEO,
    payload: request,
  };
}
